import { useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import routes from 'routes';

export default () => {
    const [isLoading, setIsLoading] = useState(false); // Start false
    const [userAgentsUrl, setAgentsUrl] = useState([]);
    const { role } = useSelector(state => state.users.currentUser);

    const saveAgentsUrl = async (payload) => {
        setIsLoading(true);
        try {
            const result = await axios.post(
                `${routes.userAgent.endpoint}/insertUserAgentUrls`, 
                payload
            );
            setAgentsUrl(result.data || []);
            return result; // Return data for the component to use
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setIsLoading(false);
        }
    };

    return { isLoading, userAgentsUrl, saveAgentsUrl }; // Return the function here
};